import { Action } from "../../index";
import API from "../../../vendor/api";

import { EDIT_PROFILE_SUCCESS, EditProfileSuccessPayload } from "../appAuth/appAuth";

// Actions

export const SET_USER = "meumedico/auth/SET_USER";
export function setUser(user: API.User) {
    return {
        type: SET_USER,
        payload: {
            user
        }
    };
}

// Reducer
export interface AuthState {
    logged: boolean;
    user: API.User;
}

export interface LoginPayload {
    user: API.User;
}

const INITIAL_STATE: AuthState = {
    logged: false,  
    user: null
};

export default function reducer(state: AuthState = INITIAL_STATE, action: Action<LoginPayload | EditProfileSuccessPayload>) {
    switch (action.type) {
        case SET_USER:
            return Object.assign({}, state, {
                logged: true,
                user: (action.payload as LoginPayload).user
            });
        case EDIT_PROFILE_SUCCESS:
            return Object.assign({}, state, {
                logged: true,
                user: Object.assign({}, state.user, (action.payload as EditProfileSuccessPayload).userDefailts)
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/auth/auth.ts